<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{klpt.fctitaal_oms}} {{klpt.klpt_bedrag}} from booking {{klpt.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmKlpt">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      klpt_encrid: null,
      klpt: {}
    }
  },
  methods: {
    open(klpt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/klpt/getKlpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlpt"
          },
          getKlpt: {
            klpt_encrid: klpt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klpt = res.data.getKlpt;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmKlpt() { 
      this.$axios
        .post("ares/json/ares/huov/klpt/rmKlpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmKlpt"
          },
          rmKlpt: {
            klpt_encrid: this.klpt.klpt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmKlpt.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmKlpt.text,
              color: res.data.rmKlpt.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

